import { render, staticRenderFns } from "./Pomodorus.vue?vue&type=template&id=39c84aad&scoped=true&"
import script from "./Pomodorus.vue?vue&type=script&lang=js&"
export * from "./Pomodorus.vue?vue&type=script&lang=js&"
import style0 from "./Pomodorus.vue?vue&type=style&index=0&id=39c84aad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c84aad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VIcon,VRow})
